import { assert_string_hash_sha256 } from '@shared/asserts/utils_asserts';
import { ENUM__string_id_empty } from '@shared/constants/ENUM__string_id_empty';
import { ENUM__dto_class_name } from '@shared/serialization/ENUM__dto_class_name';
import { DTO_GRAPH__instance } from '../../_graph/DTO_GRAPH__instance';
import { FIELD__base } from '../_base/FIELD__base';
import { ENUM__field_connectable_type } from '../_base/_methods/ENUM__field_connectable_type';

export class FIELD__image_segments extends FIELD__base {
  /*
   * STATIC FIELDS
   */

  static _class_name_static = ENUM__dto_class_name.GRAPH_FIELD_IMAGE_SEGMENTS;

  /*
   * META
   */
  hash_sha256_content_source!: string;

  /*
   * PROPERTIES
   */

  field_connectable__type() {
    return ENUM__field_connectable_type.IMAGE_SEGMENTS;
  }

  field_connectable__value(graph: DTO_GRAPH__instance) {
    return ``;
  }

  /*
   * METHODS
   */

  constructor() {
    super();

    this.hash_sha256_content_source = ENUM__string_id_empty.HASH_SHA256;
  }

  assert_standard_fields(): void {
    assert_string_hash_sha256(this.hash_sha256_content_source);
  }
}
